<template>
    <div class="launch">
        <p style="font-size: 32px;">Transactions</p>
        <div class="transactionsList">
            <div class="transaction" v-for="item in 100" :key="item">
                <p>ffff</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TransactionsComponent',
        data() {
            return {
                
            }
        },
        methods: {
            
        },
        setup() {
            
        }
    }
</script>

<style scoped>
.launch {
    width: 30% !important;
    margin: 0 auto;
    max-height: 80vh;
    left: 50%;
    top:50%;
    transform: translateX(-50%) translateY(-50%);
    padding: 2%;
    background-color: #191919;
    border-radius: 14px;
    text-align: left;
    filter: drop-shadow(0 0 6px #191919);
}
.transactionsList {
    max-height: 60vh;
    overflow-y: auto;
}
</style>